import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import React from 'react'
import { useDispatch } from 'react-redux'
import { updateNotes } from '../../../../redux/actions';
import '../styles.css'

const MarkCompletedBtn = ({ res, editHandler }) => {
    const dispatch = useDispatch();
    const menu = (
        <Menu
            className="joblisting-dropdown"
         onClick={editHandler}
        >
            <Menu.Item key="Edit">
                Edit
            </Menu.Item>

            <Menu.Item key="Delete">
                Delete
            </Menu.Item>
        </Menu>
    );
    return (
        <div>
            <Button className='notes-reminders-btn'
                onClick={() => {
                    dispatch(updateNotes({
                        noteId: res?._id,
                        Status: 'completed',
                    }))
                }}
            >Mark as Completed</Button>
            <Dropdown overlay={menu} trigger={["click"]}
            // onClick={() => {
            //     setSelectedNote(res)
            // }}
            >
                <MoreOutlined />
            </Dropdown>
        </div>
    )
}
export default MarkCompletedBtn